{
    "Profile_Logs.apiLogs": "API Logs",
    "Profile_Logs.event": "Event",
    "Profile_Logs.calls": "Calls",
    "Profile_Logs.request": "Request",
    "Profile_Logs.response": "Response",
    "Profile_Logs.error": "Error",
    "Profile_Logs.timestampUtc": "Timestamp (UTC)",
    "Profile_Logs.close": "Close",
    "Profile_Logs.copy": "Copy",
    "Profile_Logs.textCopied": "Text Copied!",
    "Profile_Logs.noLogs": "No logs yet!"
}
